// frontend/src/pages/Socrates/contexts/SocratesContext.js

import React, { createContext, useContext, useState, useEffect } from 'react';
import { useUser } from '../../../contexts/UserContext';

const SocratesContext = createContext();

export const useSocrates = () => {
  const context = useContext(SocratesContext);
  if (!context) {
    throw new Error('useSocrates must be used within a SocratesProvider');
  }
  return context;
};

export const SocratesProvider = ({ children }) => {
  const { user: userData, isLoading: userLoading } = useUser();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [enterpriseId, setEnterpriseId] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  useEffect(() => {
    if (userData) {
      setEnterpriseId(userData.enterprise_id);
      setUserRole(userData.role_key);
      setIsSuperAdmin(userData.role_key === 'super_admin');
      console.log('User data loaded in Socrates:', { 
        enterpriseId: userData.enterprise_id,
        role: userData.role_key,
        isSuperAdmin: userData.role_key === 'super_admin'
      });
    }
  }, [userData]);

  const value = {
    loading: loading || userLoading,
    setLoading,
    error,
    setError,
    enterpriseId,
    setEnterpriseId,
    userRole,
    isSuperAdmin,
    userData
  };

  return (
    <SocratesContext.Provider value={value}>
      {children}
    </SocratesContext.Provider>
  );
};